'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { Body, H5, InputOTP, InputOTPGroup, InputOTPSlot } from '@material-bank/mb3-components';
import { useShake } from '@material-bank/mb3-components/utils';
import { useTranslations } from '@material-bank/i18n';
import { useOtpStep } from '../../../hooks/useOtpStep';
type DialogOtpStepProps = {
  email: string;
  isLoading: boolean;
  error: string | null;
  onSubmit: (otp: string) => void;
  onResend: () => void;
};
export function DialogOtpStep(t0) {
  const $ = _c(38);
  const {
    email,
    isLoading,
    error,
    onSubmit,
    onResend
  } = t0;
  const t = useTranslations("authentication.dialog");
  let t1;
  if ($[0] !== error || $[1] !== onResend || $[2] !== onSubmit) {
    t1 = {
      onSubmit,
      onResend,
      error
    };
    $[0] = error;
    $[1] = onResend;
    $[2] = onSubmit;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    otp,
    setOtp,
    countdown,
    completeHandler,
    resendHandler,
    keyDownHandler,
    inputRef
  } = useOtpStep(t1);
  const {
    ref: shakeRef,
    shakeIfMotionAllowed
  } = useShake();
  let t2;
  let t3;
  if ($[4] !== error || $[5] !== shakeIfMotionAllowed) {
    t2 = () => {
      if (!error) {
        return;
      }
      shakeIfMotionAllowed();
    };
    t3 = [error, shakeIfMotionAllowed];
    $[4] = error;
    $[5] = shakeIfMotionAllowed;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== email || $[9] !== t) {
    t4 = t("otpHeading", {
      email
    });
    $[8] = email;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <H5 className="break-words">{t4}</H5>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [...Array(6)].map(_temp);
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== completeHandler || $[15] !== inputRef || $[16] !== isLoading || $[17] !== keyDownHandler || $[18] !== otp || $[19] !== setOtp) {
    t7 = <InputOTP ref={inputRef} maxLength={6} value={otp} onChange={setOtp} onComplete={completeHandler} onKeyDown={keyDownHandler} disabled={isLoading} autoComplete="one-time-code">{t6}</InputOTP>;
    $[14] = completeHandler;
    $[15] = inputRef;
    $[16] = isLoading;
    $[17] = keyDownHandler;
    $[18] = otp;
    $[19] = setOtp;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== shakeRef || $[22] !== t7) {
    t8 = <div ref={shakeRef}>{t7}</div>;
    $[21] = shakeRef;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== error) {
    t9 = error ? <Body variant="small" className="text-red-600">{error}</Body> : null;
    $[24] = error;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== countdown || $[27] !== isLoading || $[28] !== resendHandler || $[29] !== t) {
    t10 = countdown > 0 ? <Body variant="small" className="text-muted-foreground">{t("resendCountdown", {
        countdown
      })}</Body> : <Body variant="small" className="text-muted-foreground"><button type="button" onClick={resendHandler} disabled={isLoading} className="underline underline-offset-4 hover:text-foreground disabled:opacity-50">{t("resendButton")}</button></Body>;
    $[26] = countdown;
    $[27] = isLoading;
    $[28] = resendHandler;
    $[29] = t;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t8 || $[33] !== t9) {
    t11 = <div className="flex flex-col gap-3">{t8}{t9}{t10}</div>;
    $[31] = t10;
    $[32] = t8;
    $[33] = t9;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== t11 || $[36] !== t5) {
    t12 = <div className="flex flex-col gap-6 p-1">{t5}{t11}</div>;
    $[35] = t11;
    $[36] = t5;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  return t12;
}
function _temp(_, i) {
  return <InputOTPGroup key={i}><InputOTPSlot index={i} /></InputOTPGroup>;
}